import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { Stack } from "@mui/material";

export const ListingCoachTeamShield = () => {
  const coachData = useSelector(
    (state: RootState) => state.trainingPlan.listingData.user
  );
  const theme = useSelector((state: RootState) => state.theme);

  return (
    <Stack
      sx={{
        border: 1,
        borderColor: theme.componentColors.surface.onSurface,
        backgroundColor: theme.componentColors.surface.surfaceDim,
      }}
      className="w-[28px] h-[28px] lg:w-[46px] lg:h-[46px] rounded-full items-center justify-center "
    >
      <img
        className="w-[28px] h-[28px] lg:w-[36px] lg:h-[36px] object-cover rounded-full"
        alt={`Team Shield | ${
          coachData.organisations[coachData.organisations.length - 1].name
        }`}
        src={coachData.organisations[coachData.organisations.length - 1].url}
      />
    </Stack>
  );
};
